import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8f73f39c")

_pushScopeId("data-v-8f73f39c")
const _hoisted_1 = { class: "pop-inner-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "pop-wrapper-bg-icon circle-right"
}
const _hoisted_3 = {
  key: 1,
  class: "pop-wrapper-bg-icon circle-top"
}
const _hoisted_4 = {
  key: 2,
  class: "pop-wrapper-bg-icon cup"
}
const _hoisted_5 = {
  key: 3,
  class: "pop-wrapper-bg-icon flower"
}
const _hoisted_6 = {
  key: 4,
  class: "pop-wrapper-bg-icon spot"
}
const _hoisted_7 = {
  key: 5,
  class: "pop-wrapper-bg-icon star-top"
}
const _hoisted_8 = {
  key: 6,
  class: "pop-wrapper-bg-icon star-middle"
}
const _hoisted_9 = {
  key: 7,
  class: "pop-wrapper-bg-icon flower-left"
}
const _hoisted_10 = {
  key: 8,
  class: "pop-wrapper-bg-icon light"
}
const _hoisted_11 = {
  key: 9,
  class: "pop-wrapper-bg-icon money-long"
}
const _hoisted_12 = {
  key: 10,
  class: "pop-wrapper-bg-icon money-bottom"
}
const _hoisted_13 = {
  key: 11,
  class: "pop-wrapper-bg-icon money"
}
const _hoisted_14 = {
  key: 12,
  class: "pop-wrapper-bg-icon circle-right-up"
}
const _hoisted_15 = {
  key: 13,
  class: "pop-wrapper-bg-icon flower-right"
}
const _hoisted_16 = {
  key: 14,
  class: "pop-wrapper-bg-icon circle-middle"
}
const _hoisted_17 = { class: "pop-inner-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.circleRight)
      ? (_openBlock(), _createBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.circleTop)
      ? (_openBlock(), _createBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.cup)
      ? (_openBlock(), _createBlock("div", _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.flower)
      ? (_openBlock(), _createBlock("div", _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.spot)
      ? (_openBlock(), _createBlock("div", _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.starTop)
      ? (_openBlock(), _createBlock("div", _hoisted_7))
      : _createCommentVNode("", true),
    (_ctx.starMiddle)
      ? (_openBlock(), _createBlock("div", _hoisted_8))
      : _createCommentVNode("", true),
    (_ctx.flowerLeft)
      ? (_openBlock(), _createBlock("div", _hoisted_9))
      : _createCommentVNode("", true),
    (_ctx.light)
      ? (_openBlock(), _createBlock("div", _hoisted_10))
      : _createCommentVNode("", true),
    (_ctx.moneyLong)
      ? (_openBlock(), _createBlock("div", _hoisted_11))
      : _createCommentVNode("", true),
    (_ctx.moneyBottom)
      ? (_openBlock(), _createBlock("div", _hoisted_12))
      : _createCommentVNode("", true),
    (_ctx.money)
      ? (_openBlock(), _createBlock("div", _hoisted_13))
      : _createCommentVNode("", true),
    (_ctx.circleRightUp)
      ? (_openBlock(), _createBlock("div", _hoisted_14))
      : _createCommentVNode("", true),
    (_ctx.flowerRight)
      ? (_openBlock(), _createBlock("div", _hoisted_15))
      : _createCommentVNode("", true),
    (_ctx.circleMiddle)
      ? (_openBlock(), _createBlock("div", _hoisted_16))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_17, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
})